import PropTypes from "prop-types"
import { intComma } from "humanize-plus"

const ActiveUsers = ({ activeUsersTotal }) => (
  <div className="stat-box active-users">
    <h3>Users with enabled Applets</h3>
    <p className="stat">{intComma(activeUsersTotal)}</p>
  </div>
)

ActiveUsers.propTypes = {
  activeUsersTotal: PropTypes.number.isRequired,
}

export default ActiveUsers
